import type { FunctionComponent } from 'react';
import { ControlLabel } from 'react-bootstrap';
import Select from '../Select/Select';

export type MultiSelectFilterOption = {
  label: string;
  value: string;
};

export type Props = {
  /**
   * Title displayed above the select filter
   */
  title: string;
  /**
   * Placeholder text displayed before any text is entered
   */
  placeholder: string;
  /**
   * Currently selected values in the dropdown
   */
  values: MultiSelectFilterOption[];
  /**
   * Available options to be selected
   */
  options?: MultiSelectFilterOption[];
  /**
   * Is the select disabled
   */
  isDisabled?: boolean;
  /**
   * function to be called on filter change
   */
  onChange: (selected: MultiSelectFilterOption[]) => void;
  /**
   * id used for selenium testing
   */
  testId?: string;
};

/**
 * Renders a filter group with filter options as a multi-select dropdown. Wraps react-select.
 * @deprecated - Use FilterCardMultiSelect instead.
 */
const MultiSelectFilter: FunctionComponent<Props> = ({
  title,
  placeholder,
  values,
  options,
  isDisabled,
  onChange,
  testId,
}) => {
  return (
    <div className="multiselect-filter-group" data-test-id={testId}>
      <ControlLabel className="multiselect-filter-group-title">{title}</ControlLabel>
      <Select
        isMulti
        isClearable
        isDisabled={isDisabled}
        className="multiselect-filter-group-select"
        id={title}
        placeholder={placeholder}
        value={values}
        options={options}
        onChange={onChange}
      />
    </div>
  );
};

export default MultiSelectFilter;
